import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const get_subscription_plans = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/subscriptions/plans?${params}`
	);
	return response.data;
};
export const update_subscription_plans = async ({ id, body }) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/subscriptions/plans/${id}`,
		body
	);
	return response.data;
};

export const create_subscription_plan = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/subscriptions/plans`,
		body
	);
	return response.data;
};

export const restaurant_gift_config = async (body) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.GIFT}/restaurant-gifts/config`,
		body
	);
	return response.data;
};

export const get_restaurant_subscriptions = async (params) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.SUPERADMIN_BFF}/subscriptions/restaurant?${params}`
	);
	return response.data;
};

export const get_restaurant_subscription_by_id = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.GIFT}/restaurant-gifts/config/${id}`
	);
	return response.data;
};

export const patch_restaurant_subscription_by_id = async (body) => {
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.GIFT}/restaurant-gifts/config`,
		body
	);
	return response.data;
};

export const get_subscription_history_by_restaurant = async (id) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.ACCOUNTING}/subscriptions/restaurant/${id}/history`
	);
	return response.data;
};
